import { startCase } from 'lodash';
import React from 'react';

import { env } from '~/commons/config';
import FormGroup from '~/commons/components/FormGroup.jsx';

const FieldBasics = ({
  record, sales = [], status = [], refCodeName, disabled,
}) => (
  <>
    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
    <div className="row">
      <div className="col">
        <FormGroup name="refCode" label={refCodeName ?? 'Ref Code'} disabled={disabled || !record} />
      </div>
    </div>
    <div className="row">
      <div className="col">
        {['', ...status].includes(record?.status || '') ? (
          <FormGroup name="status" as="select" disabled={disabled}>
            <option value=""> - </option>
            {status.map((v) => (
              <option value={v} key={v}>
                {startCase(v)}
              </option>
            ))}
          </FormGroup>
        ) : (
          <FormGroup name="status" disabled />
        )}
      </div>
      <div className="col">
        <FormGroup
          name="orgId"
          label="Organization ID"
          disabled={disabled || !env?.user?.roles?.includes('admin')}
        />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="projectNo" disabled={disabled} />
      </div>
      <div className="col">
        <FormGroup name="issuedBy" as="select" disabled={disabled}>
          <option value=""> - </option>
          {sales.map((v) => (
            <option value={v._id} key={v._id}>
              {`${v.showroom?.orgId ? `${v.showroom?.orgId} - ` : ''}${startCase(
                v.name?.full?.en || '',
              )}`}
            </option>
          ))}
        </FormGroup>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="customer.erpId" label="Customer ERP ID" disabled={disabled || !!record} />
      </div>
    </div>
  </>
);

export default React.memo(FieldBasics);
